((window, document) => {
  // Pre-populate the comments field on the enquiry form
  // Note: This file contains logic to detect a make/model
  // page and pre-populate the comments field accordingly.
  // This has been retained for legacy purposes.
  const { pathname } = window.location;
  const isEnquirePage = /\/(enquire|contact)(\/|$)/.test(pathname);
  const isMakeModelEnquire = /^\/[a-z0-9-]+-vans\/[a-z0-9-]+\/enquire\/?$/.test(pathname);

  function toTitleCase(phrase) {
    return phrase
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  if (isEnquirePage) {
    const commentsField = document.getElementById('Q46');
    if (commentsField) {
      commentsField.value = [
        'To help us find you the very best deal on your new van please provide the following information (optional)',
        '',
        'How many miles do you expect to drive each year?',
        '',
        'How many years would you like to keep the van?',
        '',
        'How much deposit would you like to put down up front?',
        '',
        'Is there anything else we should know?',
      ].join('\r\n');
    }
  } else if (isMakeModelEnquire) {
    const array = pathname.split('/');
    const model = toTitleCase(array[2].replaceAll('-', ' '));
    const comments = `I would like to enquire about a ${model} van`;
    document.getElementById('Q46').value = comments;
  }
})(window, document);
